// extracted by mini-css-extract-plugin
export var actionButton = "_rq-0";
export var actionMenuContainer = "_rq-i";
export var bubble = "_rq-2";
export var bubbleActionMenu = "_rq-j";
export var bubbleContext = "_rq-6";
export var bubbleItems = "_rq-7";
export var customer = "_rq-3";
export var divider = "_rq-8";
export var fileList = "_rq-9";
export var hiddenComment = "_rq-o";
export var infoAbove = "_rq-a";
export var internal = "_rq-4";
export var lightActionButton = "_rq-1";
export var link = "_rq-b";
export var merchant = "_rq-5";
export var message = "_rq-c";
export var profilePicture = "_rq-e";
export var quillToolbarContainer = "_rq-f";
export var senderDate = "_rq-g";
export var senderDateCustomer = "_rq-h";
export var senderName = "_rq-d";
export var time = "_rq-k";
export var uploadedImage = "_rq-l";
export var username = "_rq-m";
export var xsmall = "_rq-n";